<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card v-if="items && items.length > 0">
          <v-card-title>
            {{ $t("servicesystem.common_objects.kpi.service_volume_compared") }}
          </v-card-title>
          <v-card-text>
            <DxChart id="chart" :data-source="items" palette="Soft">
              <DxCommonSeriesSettings argument-field="date" type="bar" />
              <DxDataPrepareSettings :sorting-method="alphabetical" />
              <DxLegend vertical-alignment="bottom" horizontal-alignment="center" />
              <DxSeries value-field="lastYearValue" :name="$t('servicesystem.common_objects.kpi.last_year')" />
              <DxSeries value-field="value" :name="$t('servicesystem.common_objects.kpi.this_year')" />
              <DxZoomAndPan argument-axis="both" value-axis="both" /> <!-- or "zoom" | "pan" | "none" -->
              <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" />
            </DxChart>
          </v-card-text>
        </v-card>
        <v-card v-else>
          <v-card-title>
            {{ $t("servicesystem.common_objects.fallbackterms.loading") }}
          </v-card-title>
          <v-progress-linear indeterminate></v-progress-linear>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import client from "@/api/client";
import DxChart, { DxCommonSeriesSettings, DxDataPrepareSettings, DxLegend, DxSeries, DxTooltip, DxZoomAndPan } from "devextreme-vue/chart";
export default {
  name: "ServiceVolumeGraph",
  props: [],
  components: {
    DxChart,
    DxSeries,
    DxCommonSeriesSettings,
    DxLegend,
    DxZoomAndPan,
    DxDataPrepareSettings,
    DxTooltip
  },
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    client()
      .get("/api2/serviceprovider/statistics/ServiceVolumeCompareLastYear")
      .then((response) => {
        this.items = response.data;
        this.items = this.items.map((v) => {
          v.sort = v.date;
          v.date = new Date(2024, v.date - 1).toLocaleString('default', { month: 'long' });
          return v;
        });
      });
  },
  methods: {
    alphabetical(a, b) {
      return a.sort < b.sort;
    },
    customizeTooltip(args) {
      return {
        text: `${args.argument}<br/>${args.seriesName}: ${args.value}`
      }
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>